<template>
  <b-badge class="badge-tag" :variant="variant">
    <span v-if="iconName.length > 0">
      <font-awesome-icon :icon="iconName" />
    </span>
    <span class="mx-2">
      {{ text }}
    </span>
    <span v-if="canRemove" class="pointer" @click="onCancel">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span>
  </b-badge>
</template>

<script>
export default {
  name: 'CancellableBadge',
  props: {
    variant: String,
    iconName: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    canRemove: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel', {})
    },
  },
}
</script>

<style lang="scss" scoped>
.badge-tag {
  padding: 4px 8px;
  border-radius: 10px;
  margin-right: 5px;
  margin-bottom: 6px;
}
</style>
